import { c as _c } from "react/compiler-runtime";
import { Badge, LoadingSpinner } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import NodeIcon, { type NodeIconProps } from '../../base-node/components/node-icon';
type AddNodeButtonProps = {
  title: string;
  description: string;
  icon: NodeIconProps;
  isProcessing: boolean;
  onClick: () => void;
  disabled?: boolean;
  isBeta?: boolean;
};
export const AddNodeButton = t0 => {
  const $ = _c(36);
  const {
    title,
    description,
    icon,
    isProcessing,
    onClick,
    disabled,
    isBeta
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "earlyAccessBadge"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const t2 = !disabled;
  let t3;
  if ($[1] !== disabled || $[2] !== t2) {
    t3 = cx(["relative px-4 py-4 border border-tertiary rounded w-full text-left transition-colors duration-200", {
      "hover:bg-hover cursor-pointer": t2
    }, {
      "cursor-initial bg-secondary border-gray-300": disabled
    }]);
    $[1] = disabled;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isBeta || $[5] !== t) {
    t4 = isBeta && <Badge variant="info" className="absolute top-[14px] right-3">{t(_temp)}</Badge>;
    $[4] = isBeta;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== icon || $[8] !== isProcessing) {
    t5 = <div className="flex size-10 rounded items-center justify-center">{isProcessing ? <LoadingSpinner size="large" ariaLabel="Loading..." /> : <NodeIcon {...icon} />}</div>;
    $[7] = icon;
    $[8] = isProcessing;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = !disabled;
  let t7;
  if ($[10] !== disabled || $[11] !== isBeta || $[12] !== t6) {
    t7 = cx(["text-label-2", {
      "text-primary": t6
    }, {
      "text-tertiary": disabled
    }, {
      "pr-24 md:pr-0": isBeta
    }]);
    $[10] = disabled;
    $[11] = isBeta;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7 || $[15] !== title) {
    t8 = <div className={t7}>{title}</div>;
    $[14] = t7;
    $[15] = title;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = !disabled;
  let t10;
  if ($[17] !== disabled || $[18] !== t9) {
    t10 = cx(["text-body-2 flex items-center gap-2", {
      "text-tertiary": t9
    }, {
      "text-quaternary": disabled
    }]);
    $[17] = disabled;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== description || $[21] !== t10) {
    t11 = <div className={t10}>{description}</div>;
    $[20] = description;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8) {
    t12 = <div className="flex flex-col w-full">{t8}{t11}</div>;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t5) {
    t13 = <div className="flex gap-4">{t5}{t12}</div>;
    $[26] = t12;
    $[27] = t5;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== disabled || $[30] !== onClick || $[31] !== t13 || $[32] !== t3 || $[33] !== t4 || $[34] !== title) {
    t14 = <button type="button" className={t3} onClick={onClick} tabIndex={0} disabled={disabled} key={title}>{t4}{t13}</button>;
    $[29] = disabled;
    $[30] = onClick;
    $[31] = t13;
    $[32] = t3;
    $[33] = t4;
    $[34] = title;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
function _temp($) {
  return $.label;
}